import React from 'react';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AccordionClean = ({ expanded, onToggle, title, stripeColor = 'var(--mexx-green-primary)', onEntered, children, sx }) => (
  <Box
    sx={[
      {
        position: 'relative',
        width: '100%',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '10px',
        overflow: 'hidden',
      },
      ...(Array.isArray(sx) ? sx : [sx || {}]),
    ]}
  >
    <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, bgcolor: stripeColor }} />
    <Box
      onClick={onToggle}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle();
        }
      }}
      aria-expanded={expanded}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        userSelect: 'none',
        px: 2,
        py: 1.5,
        borderBottom: expanded ? '1px solid' : 'none',
        borderColor: 'divider',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 400, color: 'text.primary' }}>
        {title}
      </Typography>
      <IconButton
        size="small"
        tabIndex={-1}
        aria-hidden="true"
        sx={{
          transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease',
        }}
      >
        <ExpandMoreIcon />
      </IconButton>
    </Box>
    <Collapse in={expanded} timeout="auto" unmountOnExit={false} onEntered={onEntered}>
      <Box sx={{ p: 2 }}>
        {children}
      </Box>
    </Collapse>
  </Box>
);

export default AccordionClean;
